"use client";

import React from "react";
import { CheckCircle2, Zap, Activity, Target, Dumbbell } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const apparatusData = [{
  id: 1,
  title: "Dijital Tasarım",
  iconName: "zap",
  point1: "3D tarama ve modelleme teknolojisi",
  point2: "Yüz hatlarıyla tam uyumlu tasarım",
  point3: "Tedavi öncesi dijital simülasyon"
}, {
  id: 2,
  title: "Ağrısız Süreç",
  iconName: "activity",
  point1: "Konforlu lokal anestezi teknikleri",
  point2: "Minimal invaziv uygulama yöntemleri",
  point3: "Hızlı ve sorunsuz iyileşme süreci"
}, {
  id: 3,
  title: "Estetik Sanat",
  iconName: "target",
  point1: "Doğal diş formu ve altın oran",
  point2: "Işık geçirgenliği yüksek materyaller",
  point3: "Kişiye özel sanatsal renk seçimi"
}, {
  id: 4,
  title: "Kalıcı Sonuçlar",
  iconName: "dumbbell",
  point1: "Yüksek dayanıklı porselen yapılar",
  point2: "Biyouyumlu ve sağlıklı malzemeler",
  point3: "Uzun ömürlü kullanım garantisi"
}];
const getIcon = (name: string) => {
  switch (name) {
    case "zap":
      return <Zap className="size-6 text-primary stroke-[0.5px]" />;
    case "activity":
      return <Activity className="size-6 text-primary stroke-[0.5px]" />;
    case "target":
      return <Target className="size-6 text-primary stroke-[0.5px]" />;
    case "dumbbell":
      return <Dumbbell className="size-6 text-primary stroke-[0.5px]" />;
    default:
      return <CheckCircle2 className="size-6 text-primary stroke-[0.5px]" />;
  }
};
export default function TrainingAndApparatus() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="170588" id="ayırcalı-gülüş-tasarımı-deneyimi" className="bg-secondary py-40 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-12 md:mb-16 transition-all duration-[800ms] ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-4 uppercase tracking-tight">
            Ayrıcalıklı <span className="text-primary italic">Gülüş Tasarımı</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-sans">
            En son dijital teknolojiler ve sanatsal bakış açısıyla, size özel en doğal ve estetik gülüşü tasarlayarak özgüveninizi yeniden inşa ediyoruz.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto transition-all duration-[1000ms] ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {apparatusData.map((item, i) => <Card key={item.id} data-index={i} className="group border-none bg-card/40 backdrop-blur-sm hover:bg-card/60 transition-all duration-500 shadow-sm hover:shadow-xl hover:-translate-y-[5px]">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center gap-3 text-2xl font-serif tracking-tight text-foreground">
                  <div className="p-2.5 rounded-lg bg-primary/5 group-hover:bg-primary/10 transition-colors">
                    {getIcon(item.iconName)}
                  </div>
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="size-5 text-primary/60 stroke-[1px] shrink-0 mt-0.5" />
                    <span className="text-muted-foreground group-hover:text-foreground transition-colors font-sans">
                      {item.point1}
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="size-5 text-primary/60 stroke-[1px] shrink-0 mt-0.5" />
                    <span className="text-muted-foreground group-hover:text-foreground transition-colors font-sans">
                      {item.point2}
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="size-5 text-primary/60 stroke-[1px] shrink-0 mt-0.5" />
                    <span className="text-muted-foreground group-hover:text-foreground transition-colors font-sans">
                      {item.point3}
                    </span>
                  </li>
                </ul>
              </CardContent>
            </Card>)}
        </div>

      </div>
    </section>;
}